import { Component, OnInit, inject, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { UsersService } from 'src/app/services/users/users.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { HeaderAppComponent } from '../../headers/header-app/header-app.component';
import { FormTemplateComponent } from '../../../shared/screen-templates/form-template/form-template.component';
import { PayeeHorizontalLineComponent } from '../../../shared/payee-horizontal-line/payee-horizontal-line.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  imports: [
    HeaderAppComponent,
    FormTemplateComponent,
    PayeeHorizontalLineComponent,
    MatProgressSpinner,
    TranslateModule,
  ],
})
export class VerifyEmailComponent implements OnInit {
  private authService = inject(AuthService);
  private snackbar = inject(MatSnackBar);
  private translate = inject(TranslateService);
  private usersService = inject(UsersService);
  private clientsService = inject(ClientsService);
  private router = inject(Router);

  resendPressed = false;
  readonly loading = signal(false);

  async ngOnInit(): Promise<void> {
    try {
      this.authService.logoutOnUnauthorized = false;
      const user = await this.usersService.setUser();
      if (user.email_verified) {
        await this.clientsService.getSelectedClient();
        await this.router.navigateByUrl(
          this.authService.next || environment.afterLoginPath,
        );
        this.authService.setNext(null);
      }
    } catch {
      // User is not logged in yet — stay on the verification page.
    } finally {
      this.authService.logoutOnUnauthorized = true;
    }
  }

  xClicked = async () => {
    await this.authService.logout();
  };

  async resendVerifyEmail() {
    if (this.resendPressed || this.loading()) {
      return;
    }

    try {
      this.resendPressed = true;
      this.loading.set(true);
      await this.authService.resendVerifyEmail();
      this.snackbar.open(
        this.translate.instant('VERIFY_TOKEN_EXPIRED.RESEND_SUCCESS'),
        this.translate.instant('OK'),
        {
          duration: 5000,
        },
      );
    } catch (error) {
      console.error(error);
      this.snackbar.open(
        this.translate.instant('ERROR_MESSAGES.UNKNOWN_ERROR'),
        this.translate.instant('OK'),
        {
          duration: 5000,
        },
      );
    } finally {
      this.loading.set(false);
      setTimeout(() => (this.resendPressed = false), 15000);
    }
  }
}
